var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 11.6667H17.3333C17.8856 11.6667 18.3333 11.2189 18.3333 10.6667V2.66666C18.3333 2.11437 17.8856 1.66666 17.3333 1.66666H6C5.44771 1.66666 5 2.11437 5 2.66666V5.41666",
    strokeWidth: 1.2,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 14.1667H12.5003M3.33366 14.1667V8.5C3.33366 7.94772 3.78138 7.5 4.33366 7.5H11.5003C12.0526 7.5 12.5003 7.94771 12.5003 8.5V14.1667M3.33366 14.1667L1.7767 18.0591C1.72415 18.1904 1.82091 18.3333 1.9624 18.3333H13.8716C14.0131 18.3333 14.1098 18.1904 14.0573 18.0591L12.5003 14.1667",
    strokeWidth: 1.2,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/Project-icon.e9cedf21c46422ef745148b5cab0386d.svg";
export { ForwardRef as ReactComponent };